module.exports = {"bg":"background2","platforms":[{"message":"start platform","type":"FiniteImmobilePlatform","x":0,"y":9,"width":11,"height":1,"display":{"assetName":"grass"}},{"message":"goal platform","type":"FiniteImmobilePlatform","x":20,"y":12,"width":5,"height":2,"display":{"assetName":"temple"}},{"message":"bottom spiked platform","type":"FiniteImmobilePlatform","x":0,"y":13,"width":20,"height":1,"display":{"assetName":"spikes"},"attributes":{"spiked":true}}],"goal":{"x":22,"y":12},"player":{"x":5,"y":8},"par":1,"scale":32}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/beta-4-spikes.json
// module id = 141
// module chunks = 0